import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddShopProductMutationVariables = Types.Exact<{
  input: Types.Shop_Products_Insert_Input;
}>;


export type AddShopProductMutation = { __typename?: 'mutation_root', insert_shop_products_one?: { __typename?: 'shop_products', id: any, product_id: any, property_id: any, product?: { __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, organization_id?: any | null, workspace_id?: any | null, created_at?: any | null, retail_price?: any | null, product_notes?: string | null, extended_price?: any | null, photo_link?: string | null, parent_product_id?: any | null, product_category: { __typename?: 'product_categories', name: string, label: string }, parent_product?: { __typename?: 'products', id: any, name: string, make: string, model: string, description: string } | null } | null, property?: { __typename?: 'properties', id: any, name: string } | null } | null };


export const AddShopProductDocument = gql`
    mutation addShopProduct($input: shop_products_insert_input!) {
  insert_shop_products_one(object: $input) {
    id
    product_id
    property_id
    product {
      id
      name
      description
      sku
      product_category {
        name
        label
      }
      make
      model
      organization_id
      workspace_id
      created_at
      retail_price
      product_notes
      extended_price
      photo_link
      parent_product_id
      parent_product {
        id
        name
        make
        model
        description
      }
    }
    property {
      id
      name
    }
  }
}
    `;
export type AddShopProductMutationFn = Apollo.MutationFunction<AddShopProductMutation, AddShopProductMutationVariables>;

/**
 * __useAddShopProductMutation__
 *
 * To run a mutation, you first call `useAddShopProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddShopProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addShopProductMutation, { data, loading, error }] = useAddShopProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddShopProductMutation(baseOptions?: Apollo.MutationHookOptions<AddShopProductMutation, AddShopProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddShopProductMutation, AddShopProductMutationVariables>(AddShopProductDocument, options);
      }
export type AddShopProductMutationHookResult = ReturnType<typeof useAddShopProductMutation>;
export type AddShopProductMutationResult = Apollo.MutationResult<AddShopProductMutation>;
export type AddShopProductMutationOptions = Apollo.BaseMutationOptions<AddShopProductMutation, AddShopProductMutationVariables>;